<template>
	<localizer>
		<!-- UI Loader -->
		<div v-if="$root.loader" style="position: relative; opacity: 1;zoom: 1;">
			<div
				class="blockUI blockOverlay"
				style="z-index: 1000;border: none;margin: 0px;padding: 0px;width: 100%;height: 100%;top: 0px;left: 0px;bottom: 0;background-color: #eee;opacity: 0.4;cursor: wait;position: fixed;"
			></div>
			<div
				class="blockUI blockMsg blockElement"
				style="z-index: 1060;position: fixed;padding: 0px;margin: auto;width: 80px;top: 0;left: 0;text-align: center;color: rgb(0, 0, 0);border: 0px;cursor: wait;bottom: 0;right: 0;height: 20px;"
			>
				<div class="loading-message">
					<div class="block-spinner-bar">
						<div class="bounce1"></div>
						<div class="bounce2"></div>
						<div class="bounce3"></div>
					</div>
				</div>
			</div>
		</div>
		<router-view></router-view>
		<notifications area="topLeft"></notifications>
	</localizer>
</template>
<script>
	import '@coreui/icons/css/coreui-icons.min.css'
	import 'codemirror/lib/codemirror.css'
	import 'codemirror/theme/seti.css'
	import 'codemirror/theme/base16-dark.css'
	import 'codemirror/addon/hint/show-hint.css'
	import 'codemirror/lib/codemirror.css'
	import './assets/scss/style.scss'
	import 'vue2-dropzone/dist/vue2Dropzone.min.css'

	import {Localizer, Notifications} from './components/'
	import 'codemirror/addon/edit/matchbrackets.js'
	import 'codemirror/mode/sql/sql.js'
	import 'codemirror/mode/htmlembedded/htmlembedded.js'
	import 'codemirror/mode/shell/shell.js'
	import 'codemirror/addon/comment/continuecomment.js'
	import 'codemirror/addon/comment/comment.js'
	import 'codemirror/addon/hint/show-hint.js'
	import 'codemirror/addon/hint/sql-hint.js'
	import 'codemirror/addon/hint/html-hint.js'
	import 'codemirror/addon/hint/javascript-hint.js'

	export default {
		name: 'app',
		components: {
			Localizer,
			Notifications,
		}
	}
</script>


